import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFilters } from "store/filters/operations";
import { selectFilters } from "store/filters/selectors";
import { CustomDatePicker } from "reusableComponents";
import "react-datepicker/dist/react-datepicker.css"; // Import the stylesheet

import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";


const ToDateFilterBtn = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const filters = useSelector(selectFilters);
  const datePickerRef = useRef(null);

  const handleToDateChange = (date) => {
    dispatch(updateFilters({ to: date }));
  };

  return (
    <div ref={datePickerRef} className={styles.datePickerWrapper}>
      <CustomDatePicker
        selectedDate={filters.to}
        onDateChange={handleToDateChange}
        minDate={filters.from}
        className={styles.customDatePickerInput}
      />
    </div>
  );
};

export default ToDateFilterBtn;
